import axios from 'axios';

export function moduleActionUrl(actionHandle) {
  return actionHandle ? '?action=my-diy-module/' + actionHandle : window.location.href;
}

export function setAuthToken(token) {
  axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
}

export function withCsrf(data = {}) {
  const submitData = { ...data };
  submitData[window.csrfTokenName] = window.csrfTokenValue;
  return submitData;
}

export function withQuoteContext(data, { token, quoteId, testMode } = {}) {
  const submitData = withCsrf(data);
  if (token) submitData.quoteId = quoteId;
  submitData.testMode = testMode;
  return submitData;
}

export function postModuleAction(actionHandle, submitData) {
  return axios({
    url: moduleActionUrl(actionHandle),
    method: 'post',
    data: submitData,
  }).then((responseObject) => responseObject.data);
}

export function logFormErrors(response) {
  console.log('Form failed to submit');
  console.log('Field Errors', response.errors);
  console.log('Form Errors', response.formErrors);
}

export function logRequestError(error) {
  console.error('Error!');
  console.error(error);
}
